// Klaviyo's wishlist "add to cart" sets #cart-drawer's innerHTML to markup that still
// contains the #cart-drawer wrapper itself, nesting a duplicate drawer instead of
// updating the existing one in place. Discard that broken content and let the theme's
// own cart:refresh handler (CartDrawer._onCartRefresh) fetch a correct copy instead of
// trusting it.
class CartDrawerIntegrityGuard {
  constructor(cartDrawer) {
    this.cartDrawer = cartDrawer;
    this.observer = new MutationObserver(this.handleMutation.bind(this));
    this.observer.observe(this.cartDrawer, { childList: true });
  }

  handleMutation() {
    const nestedDrawer = this.cartDrawer.querySelector('cart-drawer#cart-drawer');
    if (!nestedDrawer) {
      return;
    }
    nestedDrawer.remove();
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }
}

// Klaviyo's Customer Hub router gets stuck on the favorites route when its drawer is
// closed directly (X button or backdrop click) instead of via its own "Zurück" button.
// Any later click on the account/login icon then reopens the drawer on favorites
// instead of login. Clicking Zurück first resets the route before the drawer closes.
class WishlistHubCloseGuard {
  constructor() {
    document.addEventListener('click', this.handleClick.bind(this), true);
  }

  handleClick(event) {
    const drawer = document.querySelector('.kl-hub-drawer.kl-hub-route-favorites');
    if (!drawer) {
      return;
    }

    const isCloseButton = !!event.target.closest('button[aria-label="Dialog schließen"]');
    const isOutsideDrawer = !drawer.contains(event.target);
    if (!isCloseButton && !isOutsideDrawer) {
      return;
    }

    const backButton = drawer.querySelector('button[aria-label="Zurück"]');
    if (!backButton) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    backButton.click();
    setTimeout(() => {
      document.querySelector('.kl-hub-drawer button[aria-label="Dialog schließen"]')?.click();
    }, 150);
  }
}

const cartDrawer = document.getElementById('cart-drawer');
if (cartDrawer) {
  new CartDrawerIntegrityGuard(cartDrawer);
}

new WishlistHubCloseGuard();
